import Image from "components/commons/Image";
import List from "components/commons/List";
import Video from "components/commons/Video";
import Layout from "components/layouts/Layout";
import { GetStaticProps } from "next";
import { useTranslations } from "next-intl";
import { ReactElement } from "react";
import DocPage from "../../../components/DocPage";
import FeaturesLayout from "../../../components/layouts/features/FeaturesLayout";

const translations = "orcamentacao/compor-os-precos-do-orcamento";

const Doc = () => {
  const t = useTranslations(translations);

  return (
    <DocPage
      group={t("group")}
      title={t("title")}
      metadata={{
        title: t("metadata-title"),
        description: t("metadata-description"),
      }}
      previous={{ name: t("previous-name"), to: t("previous-to") }}
      next={{ name: t("next-name"), to: t("next-to") }}
    >
      <p>{t("details-1")}</p>
      <Image
        title={t("image-1-title")}
        href={t("image-1-src")}
        width={1100}
        height={635}
      />
      <p></p>
      <p>{t("details-2")}</p>
      <List>
        <li>{t("list-1-item-1")}</li>
        <li>{t("list-1-item-2")}</li>
        <li>{t("list-1-item-3")}</li>
        <li>{t("list-1-item-4")}</li>
        <li>{t("list-1-item-5")}</li>
        <li>{t("list-1-item-6")}</li>
      </List>
      <Video id={t("video-1-id")} title={t("video-1-title")} />
      <h2>{t("heading-1")}</h2>
      <p>{t("details-3")}</p>
      <p>{t("details-4")}</p>
      <h2>{t("heading-2")}</h2>
      <p>{t("details-5")}</p>
      <p>{t("details-6")}</p>
      <Image
        title={t("image-2-title")}
        href={t("image-2-src")}
        width={1100}
        height={990}
      />
      <h2>{t("heading-3")}</h2>
      <p>{t("details-7")}</p>
      <h2>{t("heading-4")}</h2>
      <p>{t("details-8")}</p>
      <p>{t("details-9")}</p>
      <h2>{t("heading-5")}</h2>
      <p>{t("details-10")}</p>
      <p>{t("details-11")}</p>
      <h2>{t("heading-6")}</h2>
      <p>{t("details-12")}</p>
      <Video id={t("video-2-id")} title={t("video-2-title")} />
    </DocPage>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  return {
    props: {
      context,
      messages: (await import(`../../../lang/${context.locale}-docs.json`))
        .default,
    },
  };
};

Doc.getLayout = function getLayout(page: ReactElement) {
  return (
    <Layout variant="secondary">
      <FeaturesLayout>{page}</FeaturesLayout>
    </Layout>
  );
};

export default Doc;
